"use client";
import React from "react";
import Image from "next/image";
import { BsBook } from "react-icons/bs";
import { useRouter } from "next/navigation";
import { AiFillEye } from "react-icons/ai";
import { AntDesignOutlined } from "@ant-design/icons";
import { TitleCard, DesCard, NormalStyles } from "@/layouts/styles/ssr.style";
import { Avatar } from "antd";
import { formatValueReadings } from "@/utils/formatted";
import { definitions } from "@/services/metruyenvl";

interface IAuthCard {
    author?: definitions["models.AuthorMD"];
}

function AuthorCard(props: IAuthCard) {
    const { author } = props;
    const router = useRouter();
    return (
        <div className="w-full xl:h-20 md:h-18 h-14 flex gap-x-3 items-center">
            {" "}
            <Avatar
                size={{ xs: 50, sm: 56, md: 45, lg: 55, xl: 64, xxl: 70 }}
                onClick={() => {
                    router.push(`/tac-gia/${author?.slug}`);
                }}
                icon={<Image unoptimized={true} height={40} width={40} quality={100} alt="" className="h-auto w-auto cursor-pointer" src={author?.avatar ?? "/avatar.gif"} />}
            />
            <div className="w-5/6">
                <TitleCard
                    click={() => {
                        router.push(`/tac-gia/${author?.slug}`);
                    }}
                    styles={{ marginBottom: "5px" }}
                >
                    {author?.name ?? "tesst"}
                </TitleCard>
                {/* <DesCard styles={{ marginBottom: "5px" }}>
                    Võ lâm đời đời tương truyền thì Sử bút tiên sinh cũng đã truyền được 18 đời, ang lúc cực thịnh, nghiễm nhiên trở thành người đứng đầu trong Võ lâm tứ đại thế gia. Sử bút thế gia lấy văn tài nổi danh giang hồ, nhưng các Sử bút tiên sinh đều không giỏi võ công. Tuy hắc bạch lưỡng đạo thường không chủ động mạo phạm Sử bút tiên sinh, nhưng khó tránh đao kiếm không có mắt, mỗi năm đều có một hai vị Sử bút tiên sinh vô tội gặp họa, bỏ mạng hoàng tuyền.{" "}
                </DesCard> */}
                <div className="flex items-center gap-x-4">
                    <div className="flex items-center  gap-x-2">
                        {" "}
                        <AiFillEye color="rgb(107 114 128)" /> <NormalStyles>{formatValueReadings(author?.stats?.books_count ?? 0)}</NormalStyles>
                    </div>
                    <div className="flex items-center  gap-x-2">
                        <BsBook color="rgb(107 114 128)" />
                        <NormalStyles> {formatValueReadings(author?.stats?.chapters_count ?? 0)}</NormalStyles>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AuthorCard;
